import { useActiveCircle } from '@/hooks/use-active-circle';
import { useAllClinicalPacks } from '../use-all-clinical-packs';

export function useAllActiveCircleClinicalPacks(isOrdered = false) {
    const { activeCircleId } = useActiveCircle();

    return useAllClinicalPacks(activeCircleId, isOrdered);
}
